import { shallowEqual } from 'react-redux';
import { useFieldSelector } from '../../../../store/validation/validationStore';
import { useFormContext } from '../FormContext';

interface IUseFieldValue {
  formName?: string;
  name: string;
}

export default function useFieldValue<T = unknown>({
  formName,
  name,
}: IUseFieldValue) {
  const { name: hookFormName } = useFormContext();

  if (!formName && !hookFormName) {
    throw new Error(
      `useFieldValue: It was not possible to determine the formName in field with name ${name}`,
    );
  }

  const value = useFieldSelector(
    formName ?? hookFormName,
    name,
    (props) => {
      return props.value;
    },
    shallowEqual,
  );

  return value as T;
}
